import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskAadhar'
})
export class MaskAadharPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let id = value.toString();
     if(id){
      return id.slice(0, -4).replace(/./g, 'X') + id.slice(-4);
    }
    return null 
  }
}
